<div class="fake-mode-cover" *ngIf="isFakeMode"></div>
<section class="navigation-menu-wrapper">

<div class="menus__manage-actions mb20">
  <div class="db-menu-button-wrap">
    <button class="ds-btn-black ds-btn-medium"
            (click)="navigationService.sendAnalyticsEvent('Add', website?.id);"
            [routerLink]="['./add-menu']"
            [ngClass]="{'ds-btn-disabled': false}">
      {{'text_menusAddMenu' | dbText}}
    </button>
  </div>
</div>

<section class="navigation-wrapper">
  <db-menus-table [class.add-min-length]="menus?.length">
    <ng-container>
      <ng-container *ngIf="menus?.length; else emptyTable">
        <div class="list">
          <db-menu-table-row
            *ngFor="let menu of menus"
            [menu]="menu"
            [menuUrl]="menuUrl"
            (removeItem)="onRemoveItem($event)">
          </db-menu-table-row>
        </div>
      </ng-container>
      <ng-template #emptyTable>
        <div class="empty-table"
             *ngIf="!loading">
          <span>{{'text_menusNoMenus' |dbText}}</span>
        </div>
      </ng-template>
    </ng-container>
    <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
  </db-menus-table>
</section>
</section>
